import { Form, DatePicker } from "antd";
import { GTMolecularRunFn } from "../../components/GTMolecularRunFn";

const FN_NAME = "gtm-run-pull-kits-received";

let pullKitsReceivedFormItems = (
  <>
    <Form.Item label="Date" name="date" required="true">
      <DatePicker />
    </Form.Item>
  </>
);

function FnRun() {
  return (
    <GTMolecularRunFn name={FN_NAME} formItems={pullKitsReceivedFormItems} />
  );
}

export { FnRun };
